import React, { lazy, Suspense, useEffect } from "react";
import Layout from "../../components/Layout/Layout";
import { FaSpinner } from "react-icons/fa";

const Partnerwithus = lazy(() =>
  import("../../components/Partnerwithus/Partnerwithus")
);

const Partner = () => {
  useEffect(() => {
    localStorage.removeItem("bookingvalues");
  }, []);
  return (
    <div>
      <Layout>
        <div className="pt-24 md:pt-32"></div>
        <Suspense
          fallback={
            <div className="flex items-center justify-center h-[500px]">
              <span className="animate-pulse flex text-xl font-medium text-[#f95552]">
                <FaSpinner className="animate-spin text-red-500 text-2xl" />
                <img src="/assets/logo.png" className="w-48 h-20" loading="lazy" />
              </span>
            </div>
          }
        >
          <Partnerwithus />
        </Suspense>
      </Layout>
    </div>
  );
};

export default Partner;